<template>
    <div class="flexContainer full">
        <section id="sectionPrincipal">
            <AdminTools></AdminTools>
            <section class="brand-list">
                <section class="searchResultsWrapper tabletNot">
                    <section>
                        <div class="flexContainer ai-c jc-sb">
                            <div class="flexContainer ai-c jc-sb">
                                <span class="btnExp iBlock pointer txtCenter active fright" @click="toggleCreateModal(true);">{{
                                    $t("brand.create")
                                }}</span>
                            </div>
                        </div>
                        <hr class="full mt10 separator" />
                        <transition-group name="fade" class="resultsWrapper flexContainer fw-w ">
                            <div
                                v-for="brand in brandList"
                                :key="brand.name"
                                v-if="brand.active !== false"
                                class="listDisplay rel full flexContainer fd-c ai-c jc-fs"
                                :class="[brand['theme']]"
                            >
                                <div class="listDisplay rel full flexContainer fd-c ai-c jc-fs list">
                                    <div class="listDisplay full ai-c jc-sb flexContainer">
                                        <figure class="jc-c ac-c ai-c size1of6 txtCenter">
                                            <img :src="getImgPathFig(brand.imgPath, brand.logo)" width="100" class="ac-c mt25" />
                                        </figure>
                                        <div class="flexContainer fd-c size1of6">
                                            <span class="listTitle uppercase center">{{ brand.name }}</span>
                                        </div>
                                        <div class="size1of6">
                                            <ul>
                                                <li v-for="(app, key) in brand.applications" :key="key">
                                                    {{ getTranslate(app.application.terms.name) }}
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="flexContainer fd-c size2of5">
                                            <span v-if="brand.createdUser.hasOwnProperty('firstname')">
                                                {{ $t("campaignList.createdBy") }} {{ brand.createdUser.firstname }} {{ brand.createdUser.lastname }}
                                                {{ $t("campaignList.createdOn") }} {{ brand.createdUser.dateCreated }}
                                            </span>
                                            <span v-if="brand.modifiedUser.hasOwnProperty('firstname')">
                                                {{ $t("campaignList.modifiedBy") }} {{ brand.modifiedUser.firstname }}
                                                {{ brand.modifiedUser.lastname }} {{ $t("campaignList.modifiedOn") }}
                                                {{ brand.modifiedUser.modifiedDate }}
                                            </span>
                                        </div>
                                        <div class="fd-c size1of6 content-button">
                                            <span class="roundedIcon pointer" @click="editBrand(brand);"><i class="fas fa-pencil-alt"></i></span>
                                            <span class="roundedIcon pointer" @click="editNotificationList(brand);"><i class="fas fa-list"></i></span>
                                            <span class="roundedIcon pointer" @click="deleteBrand(brand.id);"><i class="fas fa-trash-alt"></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </section>
                </section>
            </section>
            <EditBrand v-if="editStand" @hideEditBrand="modalClose($event);"></EditBrand>
            <NotificationListsModal v-if="showNotificationListsModal" @close="toggleNotificationList(false);"></NotificationListsModal>
            <CreateBrand v-if="showCreateModal" @close="toggleCreateModal(false);"></CreateBrand>
        </section>
    </div>
</template>

<script>
import httpService from "../../service";
import { mapActions } from "vuex";
import CreateStandDesign from "../CreateStandDesign.vue";
import EditStandDesign from "../EditStandDesign.vue";
import Globals from "../../globals.js";
import AdminTools from "../../adminTools/Admin";
import user from "@/services/user";
import CreateBrand from "@/components/admin/brand/CreateBrand";
import EditBrand from "@/components/admin/brand/EditBrand";
import NotificationListsModal from "@/components/admin/notifcation-lists/NotificationListsModal";

export default {
    components: {
        NotificationListsModal,
        EditBrand,
        CreateStandDesign,
        EditStandDesign,
        AdminTools,
        CreateBrand
    },
    data: () => ({
        campaign: {},
        createStandDesign: false,
        brandList: [],
        editStand: false,
        showCreateModal: false,
        showNotificationListsModal: false
    }),
    watch: {},
    methods: {
        ...mapActions({
            setBrand: "items/setBrand"
        }),
        deleteBrand(a) {
            let self = this;
            httpService.delete("/admin/brands/" + a).then(function(response) {
                if (response.code !== 400) {
                    self.$swal({
                        text: "SUCCESS",
                        type: "success",
                        confirmButtonText: self.$t("common.deconnexion"),
                        confirmButtonColor: "#41b4e8",
                        closeOnConfirm: true,
                        closeOnCancel: true,
                        allowOutsideClick: true,
                        allowEscapeKey: false,
                        showCancelButton: true,
                        cancelButtonText: self.$t("brandCreate.seeNewCancelBtnText"),
                        html: self.$t("deleteBrand.msgDelete")
                    })
                        .then(result => {
                            user.logout();
                        })
                        .catch(result => {
                            let urlTarget = "/brand-list";
                            this.$router.push(urlTarget);
                        });
                } else {
                    self.$swal({
                        html: self.$t("deleteBrand.confirmTitle") + "<br />" + self.$t("deleteBrand.warningText"),
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "red",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: "OK"
                    }).then(result => {
                        location.reload();
                    });
                }
            });
        },
        toggleCreateModal(value) {
            this.showCreateModal = value;
        },
        modalClose(close) {
            this.createStandDesign = close;
            this.editStand = close;
        },
        showModal() {
            this.createStandDesign = true;
        },
        editBrand(a) {
            this.editStand = true;
            this.setBrand(a);
        },
        editNotificationList(a) {
            this.toggleNotificationList(true);
            this.setBrand(a);
        },
        toggleNotificationList(value) {
            this.showNotificationListsModal = value;
        },
        getImgPathFig(imgPath, img, format) {
            return Globals.getBaseUrl() + imgPath + img;
        }
    },
    created() {
        httpService.get("/admin/brands/applications").then(response => {
            let brands = response.data;
            this.brandList = brands.sort((b1, b2) => {
                return b1.name.toLowerCase() < b2.name.toLowerCase() ? -1 : 1;
            });
        });
    }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/themes";
.btn-brand {
    margin: 1px;
}

.content-button {
    padding-right: 10px;
}

.listDisplay {
    &.dark,
    & .dark {
        background-color: map_get($dark, primary-background);
    }

    &.light,
    & .light {
        background-color: map_get($light, primary-background);
    }
}
.mobile-warn {
    padding: 10px 50px;
    margin-bottom: 10px;
    background-color: #7c3032;
    color: white;
    max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// BrandList.vue?0f14a33e